import { CONTENT_TYPES } from '@hivebrite/design-system/ContentList';
import type { PerContentListProps } from '@hivebrite/design-system/ContentList';

import type {
  RecommendedContents,
  AvailableContentTypes,
} from 'hb-react/shared/components/ContentRecommendation/types';

export const formatRecommendedContentData = (
  item: RecommendedContents[AvailableContentTypes],
): PerContentListProps[AvailableContentTypes] => {
  const baseProps = {
    contentType: item.type,
    displayContentType: true,
  };

  switch (item.type) {
    case CONTENT_TYPES.NEWS:
      return {
        ...baseProps,
        content: item.sanitizedContent,
        id: item.uuid ?? item.id, // Legacy News data has no uuid
        image: item.coverPicture?.mediumUrl,
        title: item.subject,
      };
    default:
      throw new Error(`Unsupported content type: ${item.type}`);
  }
};
